<template>
  <div>
    <dashboard-core-app-bar />
    <BodyContainer :id="'settings'">
      <BodyCard>
        <v-tabs
          show-arrows
          v-model="tab"
          :vertical="this.$vuetify.breakpoint.name=='lg' ||this.$vuetify.breakpoint.name=='md' || this.$vuetify.breakpoint.name=='xl' "
        >
          <v-tab>{{ $t("Establishment") }}</v-tab>
          <v-tab>{{ $t("Menu") }}</v-tab>
          <v-tab>{{ $t("Account") }}</v-tab>

          <v-tabs-items v-model="tab" class="pa-2">
            <v-tab-item>
              <EstablishmentSettings :settings="settings" />
            </v-tab-item>
            <v-tab-item>
              <CustomizeMenu :settings="settings" />
            </v-tab-item>
            <v-tab-item>
              <AccountSettings :settings="settings" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </BodyCard>
    </BodyContainer>
    <v-row justify="end" class="my-4 mx-5">
      <v-btn outlined color="primary" :disabled="!canSave" @click="save">{{ $t("Save") }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import router from "@/router/index";
import BodyContainer from "@/views/dashboard/components/BodyContainer";
import BodyCard from "@/views/dashboard/components/BodyCard";
import EstablishmentSettings from "@/views/dashboard/components/settings/EstablishmentSettings";
import CustomizeMenu from "@/views/dashboard/components/settings/CustomizeMenu";
import AccountSettings from "@/views/dashboard/components/settings/AccountSettings";

export default {
  components: {
    BodyContainer,
    BodyCard,
    DashboardCoreAppBar: () =>
      import("@/views/dashboard/components/core/AppBar"),
    EstablishmentSettings,
    CustomizeMenu,
    AccountSettings
  },
  data() {
    return {
      tab: "",
      waiter: true,
      settings: {}
    };
  },
  methods: {
    goBack() {
      router.replace("/");
    },
    changeBanner(url) {
      this.selected.banner = url;
    },
    changeLogo(url) {
      this.selected.logo = url;
    },
    async save() {
      let restaurant = this.restaurant;
      // console.log("aasca");
      for (let field in this.settings) {
        restaurant[field] = this.settings[field];
      }
      await restaurant.save();
    }
  },
  computed: {
    restaurant() {
      return this.$store.getters.restaurant;
    },

    areMandatorySettingsValid() {
      let areValid = true;
      areValid = areValid && this.settings.name;
      return areValid;
    },

    canSave() {
      for (let key in this.settings) {
        if (
          this.areMandatorySettingsValid &&
          key !== "colors" &&
          this.restaurant[key] !== this.settings[key] &&
          (this.restaurant[key] || this.settings[key])
        ) {
          return true;
        } else if (
          this.restaurant.colors &&
          (this.restaurant.colors.light !== this.settings.colors.light ||
            this.restaurant.colors.dark !== this.settings.colors.dark)
        ) {
          return true;
        }
      }
      return false;
    }
  },
  created() {
    this.settings = {
      name: this.restaurant.name,
      cash: this.restaurant.cash,
      card: this.restaurant.card,
      gpay: this.restaurant.gpay,
      mailSubscription: this.restaurant.mailSubscription,
      qrLogo: this.restaurant.qrLogo,
      waiter: this.restaurant.waiter,
      colors: { ...(this.restaurant.colors ? this.restaurant.colors : {}) },
      banner: this.restaurant.banner,
      logo: this.restaurant.logo,
      locale: this.restaurant.locale
    };
  }
};
</script>
